export const DEFAULT_MAX_KEYWORDS = 50

export const keywordLimitReached = (count: number, maxKeywords: number | null | undefined) =>
  maxKeywords != null && count >= maxKeywords

export const keywordOverLimit = (count: number, maxKeywords: number | null | undefined) =>
  maxKeywords != null && count > maxKeywords

export const keywordSelectionLabel = (count: number, maxKeywords: number | null | undefined) =>
  maxKeywords != null ? `${count}/${maxKeywords} selected` : `${count} selected`
